import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Currency from '@prisjakt/ui-currency';
import { FontEmphasis, FontWeight } from '@prisjakt/ui/text/variants';

import {
  PriceDisplay,
  PriceDisplayEnum,
} from 'src/components/price-list/types';

import * as S from './styles';

type Props = {
  className?: string;
  compact?: boolean;
  emphasis?: FontEmphasis;
  exclShipping: number;
  inclShipping?: number | null;
  priceDisplay: PriceDisplay;
};

export const ShippingLabel = ({
  className,
  compact = false,
  emphasis = FontEmphasis.MEDIUM,
  exclShipping,
  inclShipping,
  priceDisplay,
  ...rest
}: Props) => {
  const { t } = useContext(AppContext);

  let shippingValue: string;

  if (!inclShipping) {
    shippingValue = t('product', 'price.unknown-shipping');
  } else if (inclShipping === exclShipping) {
    shippingValue = t('product', 'price.free-shipping');
  } else {
    shippingValue =
      priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
        ? t('product', 'price.excluding-shipping', {
            price: <Currency key="currency" price={exclShipping} />,
          })
        : t('product', 'price.including-shipping', {
            price: <Currency key="currency" price={inclShipping} />,
          });
  }

  return (
    <S.ShippingLabel
      className={className}
      value={shippingValue}
      emphasis={emphasis}
      compact={compact}
      weight={FontWeight.NORMAL}
      {...rest}
    />
  );
};
